import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { baseUrl, baseimgUrl } from "../Univ";
import { Carousel } from "react-responsive-carousel";

function AddProduct() {

  // ---------------- STATES ----------------
  const sellerId = localStorage.getItem("user_id"); // Vendor ID
  const [products, setProducts] = useState([]);
  const [images, setImages] = useState([]);
  const [mainImageIndex, setMainImageIndex] = useState(0);
  const [categories, setCategories] = useState([]);
  const [colorInput, setColorInput] = useState("");
  const [form, setForm] = useState({
    name: "",
    category: "",
    price: "",
    discount_price: "",
    stock: "",
    description: "",
    colors: [],
    size: "",
    dimensions: "",

    warranty_value: "",
    warranty_unit: "month",
    warranty_description: "",
    is_active: true
  });

  // ---------------- INPUT HANDLER ----------------
  const handleChange = e => {
  let value = e.target.value;

  if (e.target.name === "category") {
    value = Number(value); // category must be an integer
  }

  setForm({ ...form, [e.target.name]: value });
};

  const handleImages = (e) => {
    setImages([...e.target.files]);
  };

  // ---------------- SUBMIT ----------------
  const submitProduct = async (e) => {
  e.preventDefault();

  try {

    const productData = new FormData();

    productData.append("seller", sellerId);   // vendor/seller id
    productData.append("category", form.category);
    productData.append("name", form.name);
    productData.append("price", form.price);
    productData.append("discount_price", form.discount_price);
    productData.append("description", form.description);
    productData.append("stock", form.stock);
    productData.append("colors", JSON.stringify(form.colors));
    productData.append("size", form.size);
    productData.append("dimensions", form.dimensions);
    productData.append("warranty_value", form.warranty_value);
    productData.append("warranty_unit", form.warranty_unit);
    productData.append("warranty_description", form.warranty_description);

    productData.append("status", '1');

    const productRes = await axios.post(
      baseUrl + "add-product/",
      productData
    );
    const productId = productRes.data.id;
    if (images.length > 0) {

      const imgData = new FormData();

      imgData.append("product", productId);
      imgData.append("main_image_index", mainImageIndex);

      images.forEach(img => {
        imgData.append("images", img);   // ✅ MUST be plural
      });

      await axios.post(
        baseUrl + "add-product-images/",
        imgData
      );
    }

    Swal.fire({
      title: "Product Added Successfully",
      icon: "success",
      timer: 3000,
      showConfirmButton: false
    });

    window.location.reload();

    setForm({
      category: "",
      name: "",
      price: "",
      description: "",
      stock: "",
      status: "active"
    });

    setImages([]);
    setMainImageIndex(0);

  } catch (error) {
    console.error("Error adding product:", error);

    Swal.fire(
      "Error",
      "Failed to add product. Check console.",
      "error"
    );
  }
};


  // ---------------- FETCH ----------------
  useEffect(() => {
  axios.get(baseUrl + "categories/")
    .then(res => {
      setCategories(res.data);
    })
    .catch(err => console.log(err));
}, []);

  const fetchProducts = () => {
    axios.get(baseUrl + "seller-products/")
      .then(res => setProducts(res.data));
  };

  useEffect(() => {
    fetchProducts();
  }, []);


  // ---------------- DELETE ----------------
  const handleDelete = (id) => {
    Swal.fire({
      title: "Delete Product?",
      showCancelButton: true
    }).then(result => {
      if (result.isConfirmed) {
        axios.delete(baseUrl + "delete-product/" + id)
          .then(() => {
            Swal.fire("Deleted", "", "success");
            fetchProducts();
          });
      }
    });
  };

  // ---------------- GRID ----------------
  const columns = [
    { field: "id", headerName: "ID", width: 70 },
    { field: "category_name", headerName: "Category", width: 70 },
    { field: "name", headerName: "Name", width: 160 },
    { field: "price", headerName: "Price", width: 120 },
    { field: "discount_price", headerName: "D.Price", width: 120 },
    { field: "stock", headerName: "Stock", width: 120 },
{
  field: "images",
  headerName: "Images",
  width: 240,

  renderCell: (params) => {
    const imgs = params.row.images || [];

    if (!imgs.length) return "No Image";

    return (
      <Carousel
        showThumbs={false}
        showStatus={false}
        infiniteLoop
      >
        {imgs.map((img, i) => (
          <div key={i}>
            <img
              src={`${baseimgUrl}${img.image}`}
              style={{
                height: "120px",
                objectFit: "contain"
              }}
            />
          </div>
        ))}
      </Carousel>
    );
  }
},
{
  field: "actions",
  headerName: "Actions",
  width: 160,
  renderCell: (params) => (
    <div className="d-flex gap-1">
      {/* Edit button */}
      <a
        href={`/seller/edit/${params.row.id}`}
        className="btn btn-primary btn-sm"
      >
        Edit
      </a>

      {/* Delete button */}
      <button
        className="btn btn-danger btn-sm"
        onClick={() => handleDelete(params.row.id)}
      >
        Delete
      </button>
    </div>
  )
}

  ];
const addColor = () => {
  if (colorInput.trim() !== "") {
    setForm({
      ...form,
      colors: [...form.colors, colorInput]
    });
    setColorInput("");
  }
};

const removeColor = (index) => {
  setForm({
    ...form,
    colors: form.colors.filter((_, i) => i !== index)
  });
};

  // ---------------- UI ----------------
  return (
    <div className="container mt-4">

      <div className="card">
        <h4 className="card-header text-center">Add Product</h4>

        <div className="card-body">

          <form onSubmit={submitProduct}>

            <input name="name" placeholder="Product Name"
              className="form-control mb-2"
              onChange={handleChange} />

       <select
  name="category"
  className="form-control mb-2"
  value={form.category?.id || form.category || ""}
  onChange={handleChange}
  required
>
  <option value="">Select Category</option>
  {categories.map((cat) => {
    // Build breadcrumb path
    let path = [cat.name];
    let p = categories.find((c) => c.id === cat.parent);
    while (p) {
      path.unshift(p.name);
      p = categories.find((c) => c.id === p.parent);
    }
    return (
      <option key={cat.id} value={cat.id}>
        {path.join(" › ")}
      </option>
    );
  })}
</select>


            <input name="price" placeholder="Price"
              className="form-control mb-2"
              onChange={handleChange} />

            <input name="discount_price" placeholder="Discount Price"
              className="form-control mb-2"
              onChange={handleChange} />

            <input name="stock" placeholder="Stock"
              className="form-control mb-2"
              onChange={handleChange} />

            <textarea name="description"
              placeholder="Description"
              className="form-control mb-2"
              onChange={handleChange} />
            <label>Colors</label>

            <div className="d-flex mb-2">
              <input
                value={colorInput}
                onChange={(e)=>setColorInput(e.target.value)}
                className="form-control"
                placeholder="Enter color"
              />
              <button
                type="button"
                onClick={addColor}
                className="btn btn-primary ms-2"
              >
                Add
              </button>
            </div>

            <div className="mb-2">
              {form.colors.map((c,i)=>(
                <span key={i} className="badge bg-success me-1">
                  {c}
                  <span
                    style={{cursor:"pointer"}}
                    onClick={()=>removeColor(i)}
                  > ✖</span>
                </span>
              ))}
            </div>

            <input
              name="size"
              placeholder="Size (S, M, XL...)"
              className="form-control mb-2"
              onChange={handleChange}
            />

            <input
              name="dimensions"
              placeholder="Dimensions (10x5x3 cm)"
              className="form-control mb-2"
              onChange={handleChange}
            />

            <div className="row">

              <div className="col-md-4">
                <input
                  name="warranty_value"
                  placeholder="Warranty Number"
                  className="form-control mb-2"
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-4">
                <select
                  name="warranty_unit"
                  className="form-control mb-2"
                  onChange={handleChange}
                >
                  <option value="month">Month</option>
                  <option value="year">Year</option>
                </select>
              </div>

            </div>

            <textarea
              name="warranty_description"
              placeholder="Warranty Description"
              className="form-control mb-2"
              onChange={handleChange}
            />

            <label>Main + Gallery Images</label>
            <input type="file"
              multiple
              className="form-control mb-2"
              onChange={handleImages} />

            <small>Select main image index:</small>
            <input type="number"
              className="form-control mb-2"
              value={mainImageIndex}
              onChange={(e) => setMainImageIndex(e.target.value)} />

            <button className="btn btn-success w-100">
              Save Product
            </button>

          </form>

        </div>
      </div>

      <div style={{ height: "100%", width: "100%" }}>
        <DataGrid
         sx={{
              boxShadow: 4,
              border: 4,
              borderColor: 'primary.light',
              '& .MuiDataGrid-cell:hover': {
                color: 'primary.main',
              },
            }}
          rows={products}
          columns={columns}
          autoHeight
          rowHeight={140}
          pageSize={10}
          components={{ Toolbar: GridToolbar }}
        />
      </div>

    </div>
  );
}

export default AddProduct;
